




























































import Vue from "vue";
import { Component } from "vue-property-decorator";
@Component
export default class LoginFormComponent extends Vue {
  email: string = "admin@admin.com";
  password: string = "admin";
  isLoading = false;
  async login() {
    var valid = (this.$refs.validator as any).isValid();
    if (!valid) {
      return;
    }
    try {
      this.isLoading = true;
      let res = await this.$api.AccountService.loginAsync({
        Email: this.email,
        Password: this.password,
      });

      if (res) {
        this.$api.SetUser({ Id: 0, Email: this.email });
        this.$router.push({ name: "default" });
      }
    } catch (error) {
      this.isLoading = false;
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
}
